import React from 'react';
import './Tutorial.css';

const Tutorial: React.FC = () => {
  return (
    <div className="tutorial-page">
      <section className="tutorial-hero">
        <div className="tutorial-container">
          <div className="tutorial-content">
            <h1 className="tutorial-title">
              How to Use Substyle
            </h1>
            <p className="tutorial-subtitle">
              Learn how to create professional animated subtitles inside Premiere Pro in less than 5 minutes.
            </p>
            <div className="tutorial-video-wrapper">
              <div className="tutorial-video-container">
                <iframe
                  src="https://player.vimeo.com/video/1213753927?title=0&byline=0&portrait=0"
                  className="tutorial-video"
                  frameBorder="0"
                  allow="autoplay; fullscreen; picture-in-picture"
                  allowFullScreen
                  title="Substyle Tutorial"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <section className="tutorial-blog">
        <div className="tutorial-container">
          <article className="tutorial-article">
            <h2 className="tutorial-article-title">Substyle in Under 5 Minutes</h2>
            
            <p className="tutorial-article-paragraph">
              A quick walkthrough showing how to use Substyle inside Premiere Pro — from creating your first captions to editing them directly in the Substyle interface.
            </p>
            
            <p className="tutorial-article-paragraph">
              You'll see how the plugin handles caption timing, editing, and adjustments right inside the panel, giving you full control without leaving your timeline.
            </p>
            
            <p className="tutorial-article-paragraph">
              Perfect for anyone who wants a simple, fast way to style and sync captions.
            </p>
            
            <p className="tutorial-article-contact">
              📧 Questions or feedback? Reach out at <a href="mailto:support@codec422.com" className="tutorial-contact-link">support@codec422.com</a> — we're building Substyle with the Premiere community.
            </p>
          </article>
        </div>
      </section>
    </div>
  );
};

export default Tutorial;

